<script lang="ts">
    import { _ } from 'svelte-i18n';
    import { get } from 'svelte/store';
    import { api } from '../../../../stores/api';
    import { fade } from 'svelte/transition';

    import VehicleLimitExceededIcons from '../VehicleLimitExceededIcons.svelte';
    import ToggleRouteLockIcon from '../ToggleRouteLockIcon.svelte';
    import MessageInline from '../../../shared/Messages/MessageInline.svelte';
    import type { VehicleResponseType } from '../../Vehicles/types';
    import CalcRouteButton from '../CalcRouteButton.svelte';
    import { debug, deliveryList, planning, scenarioManager } from '../../../../stores/store';
    import ColorSymbol from '../../../shared/ColorSymbol.svelte';
    import Distance from '../../../shared/Distance.svelte';
    import Duration from '../../../shared/Duration.svelte';
    import { Assignment } from '../Assignment';
    import TimeWindowsSummary from '../TimeWindowsSummary.svelte';
    import ButtonSmallBlue from '../../../shared/ButtonSmallBlue.svelte';
    import ButtonSmallDanger from '../../../shared/ButtonSmallDanger.svelte';
    import { AssignmentApi } from '../AssignmentApi';
    import IconCheck from '../../../shared/Icons/IconCheck.svelte';
    import SuccessColor from '../../../shared/SuccessColor.svelte';
    import WarningColor from '../../../shared/WarningColor.svelte';
    import Opacity from '../../../shared/Opacity.svelte';
    import Checkbox from '../../../shared/Checkbox/Checkbox.svelte';
    import QuickPlanningDeliveries from '../QuickCategories/QuickPlanningDeliveries.svelte';
    import IconRouteInProgress from '../../../shared/Icons/IconRouteInProgress.svelte';
    import { features } from '../../../shared/Features/features';
    import RouteRealisationSummary from '../PageDeliveries2/RouteRealisationSummary.svelte';
    import Dummy from '../../../shared/Dummy.svelte';
    import VehicleIcon from '../../Vehicles/VehicleIcon.svelte';
    import { Vehicle } from '../../Vehicles/Vehicle';
    import IconFlashOn from '../../../shared/Icons/IconFlashOn.svelte';
    import { Const } from '../../../../stores/Const';
    import IconPending from '../../../shared/Icons/IconPending.svelte';
    import RoutePlanningSummary from './RoutePlanningSummary.svelte';
    import ButtonSmallBlueRounded from '../../../shared/ButtonSmallBlueRounded.svelte';
    import ButtonRoundReload from '../../../shared/ButtonRoundReload.svelte';
    import lockSvg from '../../../shared/Icons/svg/lock_FILL0_wght400_GRAD0_opsz24.svg';
    import { AssignmentBulkActions } from '../AssignmentBulkActions';
    import IconDoNotDisturbOn from '../../../shared/Icons/IconDoNotDisturbOn.svelte';
    import RouteCalculatingProgress from './RouteCalculatingProgress.svelte';
    import RoutePlanningSummary2 from './RoutePlanningSummary2.svelte';
    import { availableColors } from '../../../utilities/availableColors';
    import { Umami } from '../../../utilities/Umami';

    export let assignment: Assignment;
    export let toAssign: number | null = null;
    export let vehicles: VehicleResponseType[];
    export let onClickHeader: () => void;
    export let onColorChange: ((evt: Event) => void) | null = null;
    export let showHeader: boolean = false;
    export let showActions: boolean = true;
    export let showVehicleIcon: boolean = false;
    export let showSelectCheckbox: boolean = true;
    export let visibleAssignmentIds: number[] = [];
    export let filterHideMethod: 'hide' | 'opacity';
    export let itemVisible: boolean = true;
    export let selectableAssignmentIds: number[] = [];
    export let showRouteParamsAlways: boolean = false;
    export let rejected: boolean = false;
    export let disabled: boolean = false;
    export let isToCompareOnly: boolean = false;

    let checked: boolean = false;
    // let routeDataWrapper = Dummy;
    // let actionWrapper = Dummy;
    let vehicleClass: Vehicle = new Vehicle();
    let showPendingIcon: boolean = false;

    if (!assignment.isDefault()) showActions = false;

    $: checked =
        $planning.selectedAssignments.includes(assignment.getId()) &&
        itemVisible &&
        selectableAssignmentIds.includes(assignment.getId());

    $: {
        let vehicle = vehicles.find(v => v.id === assignment.getVehicleId());
        if (vehicle) {
            vehicleClass.set(vehicle);
            vehicleClass = vehicleClass;
        }
    }

    $: {
        assignment = assignment;
        // console.log('999 - assignmentSummary', assignment.getQuickCategories().getQuantity('to_assign'));
    }

    $: {
        if (toAssign !== null && assignment.getId() === 0) {
            // console.log('999 - quickCategories update', toAssign)
            assignment.getQuickCategories().updateQuantity('to_assign', toAssign);
        }
    }
    $: showPendingIcon = assignment.isBusy();
</script>

{#if showHeader}
    <div
        class="list-element assignment-element list-element-header"
        class:noCheckbox={!showSelectCheckbox}
    >
        <div class="checkbox">
            {#if showPendingIcon}
                <IconPending spin={true} />
            {:else if showSelectCheckbox}
                <Checkbox
                    disabled={selectableAssignmentIds.length === 0 ||
                        visibleAssignmentIds.length === 0 ||
                        disabled}
                    checked={$planning.selectedAssignments.length ===
                        selectableAssignmentIds.length && selectableAssignmentIds.length > 0}
                    label=""
                    onChange={() => {
                        if ($planning.selectedAssignments.length === 0) {
                            $planning.selectedAssignments = selectableAssignmentIds;
                        } else {
                            $planning.selectedAssignments = [];
                        }
                    }}
                />
            {/if}
        </div>
        <div class="color"></div>
        <div class="name">{$_('Vehicle')}</div>
        <div class="deliveries">{$_('Deliveries')}</div>
        <div class="status">{$_('Status')}</div>
        <div class="route">{$_('Route')}</div>
        <div class="buttons"></div>
    </div>
{/if}

{#if filterHideMethod === 'hide' && !itemVisible}
    <div></div>
{:else}
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <!-- svelte-ignore a11y-no-static-element-interactions -->
    <div
        class="list-element assignment-element list-element-data"
        class:noCheckbox={!showSelectCheckbox}
        class:halfOpacity={filterHideMethod === 'opacity' && !itemVisible}
        on:click={onClickHeader}
        style="position: static"
    >
        <div class="checkbox" on:click|stopPropagation={() => {}} class:invisibleAndDisabledButNotRemoved={isToCompareOnly}>
            {#if showPendingIcon}
                <IconPending spin={true} scale={0.7} />
            {:else if showSelectCheckbox && assignment.isDefault()}
                <Checkbox
                    {checked}
                    label=""
                    disabled={assignment.isLocked() ||
                        assignment.isDownloaded() ||
                        selectableAssignmentIds.length === 0 ||
                        disabled}
                    onChange={() => {
                        checked = !checked;
                        if (checked) {
                            $planning.selectedAssignments.push(assignment.getId());
                            $planning.selectedAssignments = $planning.selectedAssignments;
                        } else {
                            $planning.selectedAssignments = $planning.selectedAssignments.filter(
                                id => id !== assignment.getId()
                            );
                        }
                    }}
                />
            {/if}
        </div>
        <div
            class="color"
            on:click={e => {
                if (onColorChange !== null) {
                    e.stopPropagation();
                }
            }}
        >
            {#if $debug}
                {#if !availableColors.includes(assignment.getColor().toLowerCase())}
                    <div title={assignment.getColor().toLowerCase()}>(!)</div>
                {/if}
            {/if}
            {#if assignment.isAdHoc()}
                <div style="position: relative; transform: translate(25%,5%);">
                    <IconFlashOn scale={0.85} />
                </div>
            {:else}
                <ColorSymbol
                    color={assignment.getColor()}
                    opts={assignment.getPinOpts()}
                    editable={onColorChange !== null && assignment.isDefault() && !disabled}
                    on:change={onColorChange}
                    scale={0.6}
                    type={null}
                />
            {/if}
        </div>

        {#if assignment.isDefault() || assignment.isVehicleGroup()}
            <div class="name dont-break">
                {#if $debug}
                    a:{assignment.getId()}
                    v:{assignment.getVehicleId()}
                {/if}
                {#if showVehicleIcon}
                    <div style="margin-right: 6px;">
                        <VehicleIcon vehicle={vehicleClass} scale={0.7} />
                    </div>
                {/if}
                <div
                    style="flex: 0 1 auto; text-overflow: ellipsis; white-space: nowrap; overflow: hidden;"
                    class:isToCompareOnly
                >
                    {#if assignment.getVehicleName() !== ''}
                        {$_(assignment.getVehicleName())}
                        {#if $debug}
                            {assignment.getType()}
                        {/if}
                    {:else}
                        <div style="opacity:0.3;">({$_('vehicle not assigned')})</div>
                    {/if}
                    {#if rejected}
                        <WarningColor>
                            <IconDoNotDisturbOn scale={0.5} title={$_('Rejected')} on:click />
                        </WarningColor>
                    {/if}
                </div>
                {#if assignment.isDownloaded() || true}
                    <div style="margin-left: 6px; color:#000;">
                        <RouteRealisationSummary
                            {assignment}
                            showProgress={false}
                            extended={true}
                        />
                        <!--                        <IconRouteInProgress-->
                        <!--                            scale={1}-->
                        <!--                            title={$_('Route is downloaded by driver')}-->
                        <!--                        />-->
                    </div>
                {/if}
            </div>
        {:else}
            <div class="name dont-break">
                <!--{#if $debug}-->
                <!--    ({assignment.getId()})-->
                <!--{/if}-->
                {#if assignment.isAdHoc()}
                    {$_('jobs_ad_hoc')}
                {:else}
                    {$_('jobs_not_assigned')}
                {/if}
            </div>
        {/if}
        <div class="deliveries">
            <QuickPlanningDeliveries {assignment} />
        </div>

        <div class="status dont-break">
            {#if assignment.isDefault() || assignment.isVehicleGroup()}
                <VehicleLimitExceededIcons
                    {assignment}
                    vehicle={vehicles.find(v => v.id === assignment.getVehicleId())}
                    warningThreshold={0.9}
                />
            {/if}
        </div>
        <div class="route" style="padding: 0; display: flex; flex-direction: column;">
            <div
                style="display: flex; flex-direction: row;align-items: center; justify-content: flex-end;"
            >
                {#if assignment.isDefault() && assignment
                        .getRsa()
                        .getBaseRoute().durationSeconds !== null && assignment
                        .getRsa()
                        .getBaseRoute().distanceMeters !== null}
                    <RoutePlanningSummary2 {assignment} color={isToCompareOnly ? "#4978e2": null} />
                {/if}
            </div>
            {#if assignment.isRouteInCalculation()}
                <RouteCalculatingProgress bind:assignment />
            {/if}
        </div>
        <!-- svelte-ignore A11y: visible, non-interactive elements with an on:click -->
        <div class="buttons dont-break" on:click|stopPropagation={() => {}} class:invisibleAndDisabledButNotRemoved={isToCompareOnly}>
            {#if !assignment.isLocked() && showRouteParamsAlways && !assignment.isDownloaded() && assignment.isDefault()}
                {#if !assignment.isRouteInCalculation() && (assignment.isRouteCalculated() || assignment.hasEstimation())}
                    <div></div>
                {:else if assignment.isRouteInCalculation() && !showRouteParamsAlways}
                    <CalcRouteButton
                        {disabled}
                        bind:assignment
                        showButtonCalc={showActions}
                        lockAssignmentAfterCalculation={true}
                    />
                {/if}
            {/if}
            {#if $debug}
                {assignment.get().stage_target_processed ? 'OK' : '-'}
            {/if}
            {#if $debug && assignment.isLocked()}
                {#if assignment.isDownloaded()}
                    <ButtonSmallDanger
                        {disabled}
                        text="Reset"
                        on:click={() => {
                            AssignmentApi.setRouteNotDownloaded(get(api), assignment.getId()).then(
                                res => {
                                    if (res) assignment.set(res);
                                    assignment = assignment;
                                }
                            );
                        }}
                    />
                {:else}
                    <ButtonSmallDanger
                        {disabled}
                        text="Download"
                        on:click={() => {
                            AssignmentApi.setRouteDownloaded(get(api), assignment.getId()).then(
                                res => {
                                    if (res) assignment.set(res);
                                    assignment = assignment;
                                }
                            );
                        }}
                    />
                {/if}
            {/if}
            {#if !assignment.isBusy()}
                {#if assignment.isDownloaded()}
                    {#if assignment.isRealised()}
                        <!--<SuccessColor>
                            <IconCheck />
                        </SuccessColor>-->
                    {:else}
                        <ToggleRouteLockIcon bind:assignment showButtons={showActions} {disabled} />
                    {/if}
                {:else if showActions}
                    {#if !assignment.isRouteCalculated() && !assignment.isRouteInCalculation()}
                        {#if assignment.getCountSuggestedJobs() > 0 && assignment.getCountDeliveries() === 0}
                            <ButtonSmallBlueRounded
                                disabled={assignment.isLocked() || disabled}
                                text={$_('Confirm')}
                                on:click={() => {
                                    console.log('not implemented yer');
                                    assignment = assignment.setBusy(true);
                                    // AssignmentBulkActions.confirmAssignment3(
                                    //     $api,
                                    //     assignment.getId(),
                                    //     $scenarioManager,
                                    //     $planning.selectedDay,
                                    //     $deliveryList.allJobIds
                                    // )
                                    AssignmentBulkActions.confirmAssignment3(
                                        $api,
                                        assignment,
                                        $planning.selectedDay,
                                        $deliveryList.allJobIds,
                                        false,
                                        (assR, unsetR) => {
                                            $scenarioManager.updateAssignment(assR);
                                            if (unsetR !== null) {
                                                $scenarioManager.updateAssignment(unsetR);
                                            }
                                            $scenarioManager = $scenarioManager;
                                        }
                                    )
                                        .then(errors => {
                                            console.log('done confirmAssignment');
                                            Umami.event('planning_assign_jobs', { assignment_id: assignment.getId() });
                                            if (errors.length > 0) {
                                                console.log('errors', errors);
                                            }
                                        })
                                        .catch(err => {
                                            console.error('err', err);
                                        })
                                        .finally(() => {
                                            assignment = assignment.setBusy(false);
                                        });
                                }}
                            />
                        {:else}
                            <CalcRouteButton
                                {disabled}
                                bind:assignment
                                showButtonCalc={showActions}
                                lockAssignmentAfterCalculation={true}
                            />
                        {/if}
                    {:else if assignment.isRouteCalculated() && (!assignment.isLocked() || !assignment.hasRouteBeenEverDownloaded())}
                        <ToggleRouteLockIcon bind:assignment showButtons={showActions} {disabled} />
                    {/if}
                {/if}
            {/if}
        </div>
    </div>
{/if}

<style>
    .assignment-element {
        display: grid;
        grid-template-columns: 35px 30px minmax(100px, 1fr) 100px minmax(30px, auto) 140px minmax(
                120px,
                auto
            );
        grid-template-areas: 'checkbox color name deliveries status route buttons';
        align-items: center;
        position: relative;
        container-type: inline-size;
    }
    .assignment-element.noCheckbox {
        margin-left: 37px;
    }
    .assignment-element.list-element-header .deliveries {
        display: flex;
        justify-content: center;
    }
    .assignment-element .route {
        display: flex;
        justify-content: center;
        padding: 0 10px;
    }
    .assignment-element.list-element-header .buttons {
        display: flex;
        justify-content: flex-start;
        padding: 0 10px;
    }
    .color {
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .checkbox {
        width: 35px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .name,
    .deliveries,
    .status,
    .buttons {
        min-height: var(--row-height);
        display: flex;
        align-items: center;
    }
    .name {
        grid-area: name;
        padding: 0;
        overflow: hidden;
    }
    .status {
        justify-content: center;
        padding: 0 !important;
    }
    .deliveries {
        grid-area: deliveries;
        display: flex;
        justify-content: center;
    }
    .buttons {
        grid-area: buttons;
        justify-content: flex-end;
    }
    .halfOpacity {
        opacity: 0.4;
        pointer-events: none;
    }

    .invisibleAndDisabledButNotRemoved {
        opacity: 0.0;
        pointer-events: none;
    }

    .isToCompareOnly {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        color: #4978e2 !important;
    }


    /*@container (max-width: 968px) {*/
    /*    .assignment-element {*/
    /*        background-color: #9ddcff;*/
    /*        grid-template-columns: 1fr 1fr;*/
    /*        grid-template-areas:*/
    /*            'name name'*/
    /*            'deliveries deliveries'*/
    /*            'status status'*/
    /*            'route route'*/
    /*            'buttons buttons';*/
    /*        margin-left: 0;*/
    /*    }*/
    /*    .assignment-element.route {*/
    /*        background-color: #9ddcff;*/
    /*        position: relative;*/
    /*    }*/
    /*    !*.assignment-element.noCheckbox {*!*/
    /*    !*    margin-left: 0;*!*/
    /*    !*}*!*/
    /*    .color {*/
    /*        !*left: 0;*!*/
    /*        position: relative;*/
    /*        background-color: #00a651;*/
    /*    }*/
    /*    .checkbox {*/
    /*        !*left: 0;*!*/
    /*        position: relative;*/
    /*        background-color: #00a651;*/
    /*        !*width: auto;*!*/
    /*        !*margin-left: 37px;*!*/
    /*    }*/
    /*}*/
</style>
